import { TenantListDTO } from './tenant-list.dto';
import { UserListDTO } from '../user/user-list.dto';

export class TenantConnectionDTO {

    id: string;

    role: number;

    employeeNumber: string;

    salary: number;

    vacationPaid: number;

    vacationUnpaid: number;

    employmentType: number;

    employmentGrade: number;

    stewardFor: string;

    pending: boolean;

    until: Date | string;

    tenant?: TenantListDTO;

    user?: UserListDTO;

    createdBy: string;
    
    updatedBy: string;
    
    createdAt: Date;
    
    updatedAt: Date;

}
